import {
  styled,
  Typography,
  TextField as BaseTextField,
  Theme,
  CircularProgress,
} from '@material-ui/core'
import { WrapperProps, LoaderProps } from './PaginatedAutocomplete.types'

const TEXT_FIELD_HEGHT = 32
const WRAPPER_RADIUS = 10
const ICON_MIN_WIDTH = 15
const AUTOCOMPLETE_PAPER_HEIGHT = 400
const ICON_BUTTON_WIDTH = 17
const INPUT_MARGIN_RIGHT = 13
const PLACEHOLDER_OFFSET = 15
const POPPER_MAX_WIDTH = 550
const TEXTFIELD_HEIGHT_OFFSET = 2
const LOADER_OPENED_LEFT = -2
const LOADER_OPENED_TOP = -17
const LOADER_CLOSED_LEFT = 1
const LOADER_CLOSED_TOP = 3

export const LOADER_SIZE = 17

export const Loader = styled(CircularProgress)(({ isOpen }: LoaderProps) => ({
  position: 'absolute',
  right: isOpen ? LOADER_OPENED_LEFT : LOADER_CLOSED_LEFT,
  top: isOpen ? LOADER_OPENED_TOP : LOADER_CLOSED_TOP,
}))

export const Wrapper = styled('div')(({ theme, isOpen }: WrapperProps) => ({
  width: '100%',
  '& .MuiAutocomplete-popper': {
    height: AUTOCOMPLETE_PAPER_HEIGHT,
    '& .MuiAutocomplete-paper': {
      minWidth: '100%',
      width: 'max-content',
      maxWidth: POPPER_MAX_WIDTH,
      '& .MuiAutocomplete-listbox': {
        '& .MuiAutocomplete-option': {
          backgroundColor: 'unset',
          padding: 0,
          '& button': {
            whiteSpace: 'nowrap',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            padding: theme.spacing(1, 2, 1, 0.5),
            fontSize: 12,
          },
        },
        '& .MuiAutocomplete-option[data-focus="true"]': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
  },
  '& .MuiAutocomplete-root': {
    borderRadius: WRAPPER_RADIUS,
    width: '100%',
    '& .MuiFormControl-root': {
      '& .MuiInputBase-root': {
        height: TEXT_FIELD_HEGHT,
        width: '100%',
        padding: theme.spacing(0.7, 0.8, 0.8),
        color: 'black',
        border: `1px solid ${
          isOpen ? theme.palette.primary.main : theme.palette.text.disabled
        }`,
        '& input': {
          padding: theme.spacing(),
          paddingRight: theme.spacing(3.3),
          color: 'rgba(0,0,0,0.8)',
          height: TEXT_FIELD_HEGHT + TEXTFIELD_HEIGHT_OFFSET,
          width: 'calc(105% + 6px)',
          flexShrink: 0,
          transform: 'translate(-8px, -8px)',
        },
        '& .MuiTouchRipple-root': {
          display: 'none',
        },
        '& fieldset': {
          border: 'none',
        },
        '& .MuiAutocomplete-endAdornment': {
          '& .MuiButtonBase-root': {
            color: theme.palette.primary.main,
            minWidth: ICON_MIN_WIDTH,
            width: ICON_BUTTON_WIDTH,
            margin: theme.spacing(0, 0.5, 1, 1),
            transition: 'all .3s',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
      },
      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
    },
  },
}))

export const RippleWrapper = styled('div')({
  borderRadius: WRAPPER_RADIUS,
  position: 'relative',
})

export const ShowAllText = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(),
}))

export const CustomPlaceholder = styled('div')(
  ({ theme, isFocused }: { theme: Theme; isFocused: boolean }) => ({
    width: `calc(100% - ${
      ICON_MIN_WIDTH + INPUT_MARGIN_RIGHT + PLACEHOLDER_OFFSET
    }px)`,
    position: 'absolute',
    display: 'flex',
    color: isFocused ? theme.palette.text.disabled : 'initial',
    justifyContent: 'flex-start',
    paddingTop: theme.spacing(0.2),
    paddingLeft: theme.spacing(0.8),
    '& :first-child': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      flex: '1 1',
      textAlign: 'left',
    },
    '& :nth-child(2n)': {
      fontWeight: 600,
      marginLeft: theme.spacing(0.2),
    },
  })
)

export const TextField = styled(BaseTextField)({
  position: 'relative',
})
